import { render, staticRenderFns } from "./AllDids.vue?vue&type=template&id=3a36df62&scoped=true&"
import script from "./AllDids.vue?vue&type=script&lang=js&"
export * from "./AllDids.vue?vue&type=script&lang=js&"
import style0 from "./AllDids.vue?vue&type=style&index=0&id=3a36df62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a36df62",
  null
  
)

component.options.__file = "AllDids.vue"
export default component.exports